import { apiRequest } from "./functionsClient";

// SBot Labs admin endpoints (functions/src/sbotMemberships.ts /admin routes).

export interface BootstrapSummariesResult {
  scannedUserCount: number;
  skippedUserCount: number;
  writtenSummaryCount: number;
  writtenBatchCount: number;
}

export function bootstrapMemberSummaries(): Promise<BootstrapSummariesResult> {
  return apiRequest("/admin/member-summaries/bootstrap", { method: "POST", body: {} });
}

export interface LeagueAdminRepairResult {
  scannedLeagueCount: number;
  scannedUserCount: number;
  repairedDocumentAdminCount: number;
  promotedSoleOrganizationAdminCount: number;
  skippedExistingLeagueAdminCount: number;
  skippedMissingAdminUserCount: number;
  skippedNoOrganizationAdminCount: number;
  skippedMultipleOrganizationAdminsCount: number;
}

export function repairLeagueAdmins(): Promise<LeagueAdminRepairResult> {
  return apiRequest("/admin/league-admins/repair", { method: "POST", body: {} });
}

export function removeLeagueManager(userID: string, leagueID: string): Promise<void> {
  return apiRequest("/admin/staff/remove-league-manager", { method: "POST", body: { userID, leagueID } });
}

/** League-admin gated: sets which home cards a staff membership can see. */
export function updateStaffHomeCards(params: {
  userID: string;
  leagueID: string;
  membershipID: string;
  visibleHomeCardIDs: string[];
}): Promise<void> {
  return apiRequest("/admin/staff/home-cards", { method: "POST", body: params });
}
